import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#1A1A1A] text-white" data-testid="footer">
      {/* Gradient Line */}
      <div className="gradient-line" />
      
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <img 
              src="/logo-bunt.jpg" 
              alt="Amitalia e.V." 
              className="h-20 w-auto"
            />
            <p className="text-white/60 text-sm leading-relaxed">
              {t('hero_slogan')}
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-body font-semibold text-sm tracking-wider uppercase text-white/80">
              Navigation
            </h4>
            <nav className="flex flex-col gap-2">
              <Link to="/" className="text-white/60 hover:text-white text-sm transition-colors">
                {t('nav_home')}
              </Link>
              <Link to="/about" className="text-white/60 hover:text-white text-sm transition-colors">
                {t('nav_about')}
              </Link>
              <Link to="/events" className="text-white/60 hover:text-white text-sm transition-colors">
                {t('nav_events')}
              </Link>
              <Link to="/archive" className="text-white/60 hover:text-white text-sm transition-colors">
                {t('nav_archive')}
              </Link>
            </nav>
          </div>

          {/* Membership */}
          <div className="space-y-4">
            <h4 className="font-body font-semibold text-sm tracking-wider uppercase text-white/80">
              {t('nav_membership')}
            </h4>
            <nav className="flex flex-col gap-2">
              <Link to="/membership" className="text-white/60 hover:text-white text-sm transition-colors">
                {t('hero_cta')}
              </Link>
              <Link to="/contact" className="text-white/60 hover:text-white text-sm transition-colors">
                {t('nav_contact')}
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="font-body font-semibold text-sm tracking-wider uppercase text-white/80">
              {t('nav_contact')}
            </h4>
            <div className="text-white/60 text-sm space-y-2">
              <p>Amitalia e.V.</p>
              <p>Salinenstraße 40</p>
              <p>76889 Karlsdorf-Neuthard</p>
              <p className="pt-2">info@amitalia.de</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © 2011 - {new Date().getFullYear()} Amitalia e.V. {t('footer_rights')}
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="/contact" className="text-white/40 hover:text-white transition-colors">
              {t('footer_imprint')}
            </Link>
            <Link to="/contact#datenschutz" className="text-white/40 hover:text-white transition-colors">
              {t('footer_privacy')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
